import { getDatabase, onValue, ref, Unsubscribe } from 'firebase/database'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectUserUid, setUser } from '../redux/userSlice'
import { captureException } from '@sentry/react'
import { logger } from '../helpers/logger'

export const useUserListener = () => {
    const dispatch = useDispatch()
    const userUid = useSelector(selectUserUid)
    useEffect(() => {
        let unsub: Unsubscribe

        try {
            if (userUid === undefined) return
            if (userUid === null) {
                dispatch(setUser(null))
                return
            }

            logger.debug(`ATTACH-LISTENER: USER DATA`)

            unsub = onValue(ref(getDatabase(), `users/${userUid}`), (snap) => {
                const exists = snap.exists()
                const val = snap.val()
                if (exists) {
                    dispatch(setUser(val !== null ? val : null))
                }
            })
        } catch (e) {
            captureException(e)
        }

        return () => {
            if (unsub) {
                logger.debug(`DETACH-LISTENER: USER DATA`)
                unsub()
            }
            dispatch(setUser(undefined))
        }
    }, [userUid, dispatch])
}
